import {  Component, Input, OnInit } from '@angular/core';
import { SharedDataService, Supplier } from 'ngx-paf-common';
import { Subject } from 'rxjs';

export class OngletPilotage {
  public name: string;
  public display:string;
  public href:string;
  public  hidden:() => boolean;
  public sharedDataSvc:SharedDataService;
  public livreQas?:Boolean 
}

@Component({
  selector: 'pilotage-endel',
  templateUrl: './pilotage-endel.component.html',
  styleUrls: ['./pilotage-endel.component.scss']
})
export class PilotageEndelComponent implements OnInit {
  
  private ongletsPilotage:OngletPilotage[]=[];
  
  get onglets():OngletPilotage[] {
    return this.ongletsPilotage.filter(o=>!o.hidden() &&  (o.livreQas || this.sharedDataSvc.ENVIRONMENT=='DEV'));
  }
  @Input() supplier : Supplier;
  constructor(public sharedDataSvc:SharedDataService) { 
  }


  ngOnInit(): void {
    //this.activateTabByName(this.activeTabName|| this._defaultActiveTab);
    this.sharedDataSvc.pilotageEndelIsActivated.subscribe(()=> this.reloadActiveTab.next(this.activeTabName));
    this.initOngletsPilotages();
    this.selectFirstAllowedTab();
    //this.sharedDataSvc.loggedIntUserChange.subscribe(res=>this.selectFirstAllowedTab())
    this.sharedDataSvc.loggedProfilChange.subscribe(res=>this.selectFirstAllowedTab());
    setTimeout(() => {
      this.selectFirstAllowedTab()
    }, 0);
  }

  selectFirstAllowedTab():void {
    if (!(this.activeTab) || this.activeTab.hidden()){
        if (this.onglets.length>0){
          this.activateTabByName(this.onglets[0].name);
        }
      }
  }

  initOngletsPilotages():void {
    this.ongletsPilotage =[];
    this.ongletsPilotage.push(
      {
      sharedDataSvc: this.sharedDataSvc,
      name:'tabDepenses',
      display:'Dépenses',
      href:'#paneDepenses',
      hidden():boolean{
          return ['ACH_OPERAT','ACH_FAMHA','CTRL_QUAL','ADMIN'].indexOf(this.sharedDataSvc.profil?.Cod)<0;        
      },
      livreQas :true
    });
    this.ongletsPilotage.push(
      {
      sharedDataSvc: this.sharedDataSvc,
      name:'tabSuiviAchats',
      display:'Suivi achats',
      href:'#paneSuiviAchats',
      hidden():boolean{
          return ['ACH_OPERAT','ACH_OPERAT_2','ACH_FAMHA','CTRL_QUAL','ADMIN'].indexOf(this.sharedDataSvc.profil?.Cod)<0;        
      },
      livreQas :true
      
    });
    this.ongletsPilotage.push(
      {
      sharedDataSvc: this.sharedDataSvc,
      name:'tabCriticite',
      display:'Criticité',
      href:'#paneCriticite',
      hidden():boolean{
          return false;
      },
      livreQas :true
    });
    this.ongletsPilotage.push(
      {
      sharedDataSvc: this.sharedDataSvc,
      name:'tabAnalyseFinanciere',
      display:'Analyse financière',
      href:'#paneAnalyseFinanciere',
      hidden():boolean{
          return ['ACH_OPERAT','ACH_OPERAT_2','ACH_FAMHA','CTRL_QUAL','ADMIN'].indexOf(this.sharedDataSvc.profil?.Cod)<0;        
      },
      livreQas :true
    });
    this.ongletsPilotage.push(
      {
      sharedDataSvc: this.sharedDataSvc,
      name:'tabQualite',
      display:'Suivi qualité',
      href:'#paneSuiviQualite',
      hidden():boolean{
          return false;
      },
      livreQas :true
    });
    this.ongletsPilotage.push(
      {
      sharedDataSvc: this.sharedDataSvc,
      name:'tabMails',
      display:'Mails',
      href:'#paneSupplierMails',
      hidden():boolean{
          return false;
      },
      livreQas :true
    });
  }

  private _defaultActiveTab: string = 'tabSuiviAchats';
  public activeTab?:OngletPilotage; //1er onglet actif par defaut

  get activeTabName():string{
    return this.activeTab?.name||'';
  }
  
  depensesVisible():boolean {
    return this.sharedDataSvc.checkProfilAccessPafSettings('PilotageENDEL_Depenses');
    // if (this.sharedDataSvc.profil?.Cod=='ACH_OPERAT_2'){
    //   return true;//Il faudra limiter l'accès à ses CDP
    // }
    //  return ['ACH_OPERAT','ACH_FAMHA','CTRL_QUAL','ADMIN'].indexOf(this.sharedDataSvc.profil?.Cod)>=0;
  }

  suiviAchatsVisible():boolean {
    return this.sharedDataSvc.checkProfilAccessPafSettings('PilotageENDEL_SuiviAchats');
  }

  criticiteVisible():boolean {
    return this.sharedDataSvc.checkProfilAccessPafSettings('PilotageENDEL_Criticite');
  }
  
  analyseFinanciereVisible():boolean {
    return this.sharedDataSvc.checkProfilAccessPafSettings('PilotageENDEL_AnalyseFinanciere');
  }

  suiviQualiteVisible():boolean {
    return this.sharedDataSvc.checkProfilAccessPafSettings('PilotageENDEL_SuiviQualite');
  }

  public editMode:boolean = false;
  public oneditModeChange(editMode:boolean){
    this.editMode = editMode;
  }

  public reloadActiveTab: Subject<string> = new Subject<string>();

  public setTabActive($event: any): void{
    this.activateTabByName($event.currentTarget.attributes['name'].value);    
  }
  public activateTabByName (tabName:string){
    if (this.activeTab?.name != tabName){
      this.activeTab = this.onglets.find(o=>o.name==tabName);
      if (this.activeTabName!=''){
        this.reloadActiveTab.next(this.activeTabName);
      }
    }
  }
}
